const menuJson = {
  // 个人中心
  personalCenterList: [
    {
      name: 'PersonalCenter', // 个人中心
      hasChildList: false,
      href: '/personalCenter/information',
      menuLogo: 'icon-user-01'
    }
  ],
  // 成员管理
  memberManageList: [
    {
      name: 'MemberManage', // 成员管理
      hasChildList: false,
      href: '/memberManage/memberManage',
      menuLogo: 'icon-investigation-01'
    },
    {
      name: 'MemberGroupManage', // 成员组管理
      hasChildList: false,
      href: '/memberManage/memberGroupManage',
      menuLogo: 'icon-managements-01'
    }
  ],
  // 任务大厅
  taskHall: [
    {
      name: 'PublicTask', // 公共任务
      matchName: '公共任务',
      hasChildList: false,
      href: '/taskHall/publicTask',
      menuLogo: 'icon-task-lawyer-01'
    },
    {
      name: 'DesignateTask', // 指派任务
      hasChildList: false,
      matchName: '指派任务',
      href: '/taskHall/designateTask',
      menuLogo: 'icon-task-lawyer-02'
    },
    {
      name: 'MyTask', // 我的任务
      hasChildList: false,
      matchName: '我的任务',
      href: '/taskHall/myTask',
      menuLogo: 'icon-task-lawyer-03'
    },
    {
      name: 'AllTask', // 全部任务
      hasChildList: false,
      matchName: '全部任务',
      href: '/taskHall/allTasks',
      menuLogo: 'icon-task-lawyer-04'
    }
  ],
  // 线索
  clueList: [
    {
      name: 'verifyClue', // 线索核实
      hasChildList: false,
      matchName: '我的线索',
      href: '/clue/verify',
      menuLogo: 'icon-clue-01'
    },
    {
      name: 'allMyClue', // 全部线索
      hasChildList: false,
      matchName: '全部线索',
      href: '/clue/all',
      menuLogo: 'icon-channel-01'
    }
  ],
  // 线索
  clueList: [
    {
      name: 'MyResult', // 我的线索
      hasChildList: false,
      matchName: '我的线索',
      href: '/clue/myClue',
      menuLogo: 'icon-clue-01'
    },
    {
      name: 'AllResult', // 全部线索
      hasChildList: false,
      matchName: '全部线索',
      href: '/clue/allClues',
      menuLogo: 'icon-channel-01'
    }
  ],
  // 案件
  caseList: [
    {
      name: 'CivilCase',
      hasChildList: true,
      matchName: 'CivilCase', // 民事案件
      href: '',
      menuLogo: 'icon-case-02',
      childList: [
        {
          name: '普通案件', // 民事案件
          hasChildList: false,
          href: '/case/civilCase',
          menuLogo: ''
        }, {
          name: '取证案件', // 行政案件
          hasChildList: false,
          href: '/case/obtainEvidenceCase',
          menuLogo: ''
        }, {
          name: '重案案件', // 重案案件
          hasChildList: false,
          href: '/case/seriousCase',
          menuLogo: ''
        }

      ]
    },
    {
      name: 'AdministrativeCase',
      hasChildList: false,
      href: '/case/administrativeCase',
      menuLogo: 'icon-case-03'
    },
    {
      name: 'CriminalCase',
      hasChildList: false,
      href: '/case/CriminalCase',
      menuLogo: 'icon-case-03'
    },
    {
      name: 'AwaitAllocationCase', // 待分配的案件
      hasChildList: false,
      matchName: '待分配的',
      href: '/case/allocatedCase',
      menuLogo: 'icon-case-04'
    },
    {
      name: 'AllCases', // 全部案件
      hasChildList: false,
      matchName: '全部案件',
      href: '/case/allCases',
      menuLogo: 'icon-case-03'
    },
    {
      name: '已转出案件',
      hasChildList: false,
      matchName: '已转出案件',
      href: '/case/transferredCases',
      menuLogo: 'icon-send-back-01'
    },
    {
      name: 'MaterialList', // 材料清单
      hasChildList: false,
      matchName: '材料清单',
      href: '/case/materialList',
      menuLogo: 'icon-materialList-lawyer-01'
    },
    {
      name: 'fxNotaryList', // 法信固证信息
      hasChildList: false,
      matchName: '法信固证信息',
      href: '/case/fxNotary',
      menuLogo: 'icon-materialList-lawyer-01'
    }
  ],
  // 项目
  projectList: [
    {
      name: 'project', // 项目
      hasChildList: false,
      href: '/project/list',
      menuLogo: 'icon-project-03'
    }
  ],
  // 系统设置
  settingsList: [
    {
      name: 'teamInfo', // 团队信息
      hasChildList: false,
      href: '/settings/teamInfo',
      menuLogo: 'icon-organization-01'
    },
    {
      name: 'authority', // 权限管理
      hasChildList: false,
      href: '/settings/authority',
      menuLogo: 'icon-agreement-04'
    },
    {
      name: 'bankCardAccount', // 银行卡账户
      hasChildList: false,
      href: '/settings/bankCardAccount',
      menuLogo: 'icon-card-01'
    },
    {
      name: 'mailingAddress', // 邮寄地址
      hasChildList: false,
      href: '/settings/mailingAddress',
      menuLogo: 'icon-project-02'
    }
  ],
  // 交易中心
  tradingCenterList: [
    {
      name: '案件预约',
      hasChildList: true,
      matchName: '案件预约',
      href: '',
      menuLogo: 'icon-trade-lawyer-01',
      childList: [
        {
          name: '公共包',
          hasChildList: false,
          href: '/tradingCenter/publicPackage'
        },
        {
          name: '指派包',
          hasChildList: false,
          href: '/tradingCenter/assignPackage'
        }
      ]
    },
    {
      name: '我的订单',
      hasChildList: false,
      matchName: '我的订单',
      href: '/tradingCenter/myOrder',
      menuLogo: 'icon-trade-lawyer-02'
    },
    {
      name: '附加订单',
      hasChildList: false,
      matchName: '附加订单',
      href: '/tradingCenter/additionalOrder',
      menuLogo: 'icon-trade-lawyer-03'
    },
    {
      name: '退案管理',
      hasChildList: false,
      matchName: '退案管理',
      href: '/tradingCenter/return',
      menuLogo: 'icon-trade-lawyer-04'
    },
    {
      name: '邮寄列表',
      hasChildList: false,
      matchName: '邮寄列表',
      href: '/tradingCenter/mailingList',
      menuLogo: 'icon-trade-lawyer-05'
    }
  ],
  // 结算中心
  settlementCenterList: [
    {
      name: '待结算案件',
      hasChildList: false,
      matchName: '待结算案件',
      href: '/settlementCenter/caseToBeSettled',
      menuLogo: 'icon-settle-lawyer-01'
    },
    {
      name: '结算管理',
      hasChildList: false,
      matchName: '结算管理',
      href: '/settlementCenter/settlementManage',
      menuLogo: 'icon-settle-lawyer-02'
    },
    {
      name: '收款记录',
      hasChildList: false,
      matchName: '收款记录',
      href: '/settlementCenter/collectionRecord',
      menuLogo: 'icon-settle-lawyer-03'
    }
  ],
  mediationCenterList: [
    {
      name: '待推送案件',
      hasChildList: false,
      href: '/mediationCenter/propellingCase',
      menuLogo: 'icon-case-03'
    },
    {
      name: '调解案件',
      hasChildList: false,
      href: '/mediationCenter/mediationCase',
      menuLogo: 'icon-case-03'
    }
  ]
}

export default {
  menuJson
}



// WEBPACK FOOTER //
// ./src/libs/menu.js